import { cn } from "@omni/utils/styles";

type AmountProps = {
    amount: number;
    className?: string;
};

const Amount = ({ amount, className }: AmountProps) => {
    if (amount < 1) {
        return null;
    }

    return (
        <div
            className={cn(
                "tw:mr-2 tw:lg:mr-0 tw:font-bold tw:text-right tw:flex-1",
                className
            )}
        >{`${amount} x`}</div>
    );
};

export { Amount };
